var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-card",
    {
      attrs: {
        title: _vm.$t("vaccines"),
        overflowVisible: "",
        hideNeuCardClass: "",
        hideButtons: _vm.historyReadOnly
      },
      on: {
        rightBtnClick: function($event) {
          _vm.showAddSection = true
        }
      }
    },
    [
      !_vm.showAddSection
        ? _c(
            "template",
            {
              slot:
                _vm.$uiHelpers.isMobile || _vm.$uiHelpers.isTablet
                  ? "append-btn-title"
                  : "right-button"
            },
            [_c("add-button")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showAddSection
        ? _c("div", { staticClass: "row mb-4" }, [
            _c(
              "div",
              { staticClass: "col-lg-5 col-12 p-1" },
              [
                _c("base-select", {
                  attrs: {
                    searchable: "",
                    loading: _vm.select.loading,
                    options: _vm.select.options,
                    label: "name",
                    valueProp: "id",
                    placeholder: _vm.$t("vaccine-ph")
                  },
                  on: { input: _vm.vaccineSelected },
                  model: {
                    value: _vm.select.value,
                    callback: function($$v) {
                      _vm.$set(_vm.select, "value", $$v)
                    },
                    expression: "select.value"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.select.value
              ? _c(
                  "div",
                  { staticClass: "col-lg-3 col-12 p-1" },
                  [
                    _c("base-select", {
                      attrs: {
                        searchable: "",
                        loading: _vm.selectLabs.loading,
                        options: _vm.selectLabs.options,
                        label: "name",
                        valueProp: "id",
                        placeholder: _vm.$t("vaccine-commercial-name")
                      },
                      model: {
                        value: _vm.selectLabs.value,
                        callback: function($$v) {
                          _vm.$set(_vm.selectLabs, "value", $$v)
                        },
                        expression: "selectLabs.value"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-lg-4 col-12 p-1" },
              [
                _c("base-datepicker", {
                  attrs: {
                    dateBeforeNow: "",
                    resetButtton: "",
                    noMarginBottom: ""
                  },
                  model: {
                    value: _vm.vaccineDate,
                    callback: function($$v) {
                      _vm.vaccineDate = $$v
                    },
                    expression: "vaccineDate"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-lg-2 col-12 p-1" },
              [
                _c("base-button", { on: { click: _vm.save } }, [
                  _vm._v(_vm._s(_vm.$t("save-btn")))
                ])
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("paginated-table", {
        attrs: {
          fields: _vm.table.fields,
          items: _vm.vaccines,
          "empty-text": _vm.$t("novaccine"),
          stacked: _vm.stacked
        },
        scopedSlots: _vm._u(
          [
            !_vm.historyReadOnly
              ? {
                  key: "cell(remove)",
                  fn: function(data) {
                    return [
                      _c("base-icon", {
                        staticClass: "clickable",
                        attrs: {
                          src:
                            "/static-appopensalud/img/icons/morillas-svg-icons/primary/remove.svg",
                          color: _vm.RED_COLOUR
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.remove(data)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.stacked
                        ? _c(
                            "span",
                            {
                              staticClass: "clickable",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.remove(data)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("remove")))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.stacked ? _c("hr") : _vm._e()
                    ]
                  }
                }
              : null
          ],
          null,
          true
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8c19d5c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c19d5c6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/HistoryVaccinesSection.vue
// module id = 2678
// module chunks = 29 32 34 141